import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.object.keys.js";

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spreadArray = this && this.__spreadArray || function (to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
    to[j] = from[i];
  }

  return to;
};

import { FhtLeancloudCustomMessageType } from "@/common/types";
import { messageType as defineMessageType, messageField, IE10Compatible } from "leancloud-realtime";
import { assert } from "@/common/assert";
export function registerCustomMessage(messageClass, messageType, fields) {
  assert(messageType, "messageType falsy");
  assert(typeof FhtLeancloudCustomMessageType[messageType] !== "undefined", "messageType invalid"); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore

  defineMessageType(messageType)(messageClass); // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore

  messageField(__spreadArray(["dt"], __read(Object.keys(fields))))(messageClass);
  IE10Compatible(messageClass);
}